import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faToolbox, faHeart, faBriefcase, faGraduationCap, faLink } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook, faTwitter, faInstagram, faMedium, faBehance, faDribbble, faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud } from '@fortawesome/free-brands-svg-icons';

import '../styles/TemplateFive.css';

const TemplateFive = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        website: faLink,
        portfolio: faLink, // Assume generic link icon
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        website: 'Website',
        portfolio: 'Portfolio',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud'
    };

    return (
        <div className="template-five" onClick={() => onClick(template?.id)}>
            <div className="template-body">
                <div className="template-column-left">
                    <div className='view-template-five-header'>
                        {template?.name && <h1 className="template-five-name" >{template?.name}</h1>}

                        {template?.image && <img src={template?.image} alt={template?.personName} className="template-five-image" />}
                    </div>
                    {template?.aboutMe && template?.aboutMe.length > 0 && (
                        <div className="profile-section">
                            <h3>Profile</h3>
                            <p>{template?.aboutMe}</p>
                        </div>
                    )}
                    {template?.workExperience && template?.workExperience.length > 0 && (
                        <div className="experience-section">
                            <h3>Experiences</h3>
                            {template?.workExperience.map((experience, index) => (
                                <div key={index} className="work-experience-item">
                                    <p className="role">{experience.role}</p>
                                    <p className="company-location">{experience.company} / {experience.location}</p>
                                    <p>
                                        {experience.location && (
                                            <p className="location">
                                                (
                                                {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                                {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                                )
                                            </p>
                                        )}
                                    </p>
                                    <p className="description">{experience.description}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    {template?.education && Array.isArray(template?.education) && template?.education.length > 0 && (
                        <div className="education-section">
                            <h3>Education</h3>
                            {template?.education.map((edu, index) => (
                                <div key={index} className="education-item">
                                    <p className="degree">{edu.degree}</p>
                                    <p className="institution">{edu.institution}</p>
                                    <p>
                                        (
                                        {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                    <p className="view-template-eight-institution">{edu.description}</p>
                                </div>
                            ))}
                        </div>
                    )}

                    {template?.certificates && (
                        <div className="education-section">
                            <h3>Certificates</h3>
                            {template?.certificates.map((certificate, index) => (
                                <div key={index} className="education-item">
                                    <p className="degree">Title: {certificate.title}</p>
                                    <p className="institution">Institution: {certificate.institution}</p>
                                    <p className="institution">
                                        Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}

                </div>
                <div className="template-column-right">
                    {template.contact && (
                        <div className="contact-section">
                            <h3>Contact</h3>
                            {template.contact.phone && <p><FontAwesomeIcon icon={faPhone} /> {template.contact.phone}</p>}
                            {template.contact.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template.contact.email}</p>}
                            {template.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template.contact.address}</p>}
                        </div>
                    )}

                    {template?.skills && template?.skills.length > 0 && (
                        <div className="skills-section">
                            <h3>Skills</h3>
                            <ul>
                                {template?.skills.map((skill, index) => (
                                    <li key={index}>{skill}</li>
                                ))}
                            </ul>
                        </div>
                    )}


                    {template.softwareSkills && template.softwareSkills.length > 0 && (
                        <div className="languages-section">
                            <h3>Software Skills</h3>
                            <ul>
                                {template.softwareSkills.map((skill, index) => (
                                    <li key={index}>{skill}</li>
                                ))}
                            </ul>

                        </div>
                    )}

                    {template?.languages && template?.languages.length > 0 && (
                        <div className="languages-section">
                            <h3>Languages</h3>
                            <ul>
                                {template?.languages.map((language, index) => (
                                    <li key={index}>{language}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {template?.hobbies && template?.hobbies.length > 0 && (
                        <div className="hobbies-section">
                            <h3>Interests</h3>
                            <ul>
                                {template?.hobbies.map((hobby, index) => (
                                    <li key={index}>{hobby}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                    {template.links && (
                        <div className="links-section">
                            <h3>Links</h3>
                            {template.links.map(([key, value]) => (
                                <p key={key} className="template-four-link">
                                    <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer"> <span className="template-three-link-text">{linkText[key]}</span></a>
                                </p>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TemplateFive;
